import { render, staticRenderFns } from "./ModalTermoUso.vue?vue&type=template&id=13a4b0e5&scoped=true"
import script from "./ModalTermoUso.vue?vue&type=script&lang=js"
export * from "./ModalTermoUso.vue?vue&type=script&lang=js"
import style0 from "./ModalTermoUso.vue?vue&type=style&index=0&id=13a4b0e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a4b0e5",
  null
  
)

export default component.exports